/**
 * Collects `name` attributes of invalid, constraint-validated controls in a form.
 * Used with `noValidate` + manual `checkValidity()` to show per-field messages.
 */
export function collectInvalidNamedControlNames(form) {
  const names = new Set();
  if (!form) return names;
  for (const el of form.elements) {
    if (!el || !('validity' in el) || !el.willValidate) continue;
    const nm = el.getAttribute('name');
    if (!nm) continue;
    if (!el.checkValidity()) names.add(nm);
  }
  return names;
}
